import { AdditionalItemForPrescriptionReleaseStruct } from "./additional-item-for-prescription-release.struct";
import { StorageAmountLocationStruct } from "./storage-amount-location.struct";

export class AdditionalItemForPrescriptionReleaseFormStruct {
    public additionalItemForPrescriptionRelease: AdditionalItemForPrescriptionReleaseStruct;

    public listStorageAmountLocationStruct: StorageAmountLocationStruct[] = [];
}